/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';
import type { EvmTokenSummaryInfo } from './EvmTokenSummaryInfo';

export type NexonTrxNftTransferInfo = {
    BNO: string;
    TRXHA: string;
    MTH: string;
    ADDRSFROMINFO: EvmAddressSummaryInfo;
    ADDRSTOINFO: EvmAddressSummaryInfo;
    VAL: string;
    TKNCTR: EvmTokenSummaryInfo;
    TKNID: string;
    TKNNM: string;
    TKNIMG: string;
    TKNTP: NexonTrxNftTransferInfo.TKNTP;
    AG: string;
    UT: number;
};

export namespace NexonTrxNftTransferInfo {

    export enum TKNTP {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }


}

